<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ title }}
      </p>
      <button @click="cancel" type="button" class="close-icon">
        <i class="mdi mdi-close"></i>
      </button>
    </header>
    <section class="modal-card-body padding-bottom82">
      <p :class="$style.modalContent">{{ content }}</p>
    </section>
    <footer class="modal-card-foot">
      <button
        class="button is-primary bg-white"
        :class="$style.confirmButton"
        @click="confirm"
      >
        {{ confirmButtonLabel }}
      </button>

      <button class="button is-primary is-rounded" @click="cancel">
        {{ cancelButtonLabel }}
      </button>
    </footer>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ConfirmationModal extends Vue {
  @Prop()
  public title!: string;
  @Prop()
  public content!: string;
  @Prop()
  public confirmButtonLabel!: string;
  @Prop()
  public cancelButtonLabel!: string;

  public confirm(): void {
    this.$emit('confirm');
    this.$emit('close');
  }
  public cancel(): void {
    this.$emit('close');
  }
}
</script>
<style module>
.confirmButton {
  color: #ff0000 !important;
}
</style>
